import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../src/constants/premissions'
import { assistantSearchSchema, healthQueryOptions } from '../../src/schemas/routeSchemas'
import { requirePermission } from '../../src/utils/routePermissions'

export const Route = createFileRoute('/assistant')({
  validateSearch: (search) => assistantSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    permissionRequired: PERMISSION_ROLES.ASSISTANT,
    layout: 'menu',
  },
})
